import api from './api';

const BASE_URL = '/school-units';

const units = () => api.get(`${BASE_URL}/units`);

export default {
  units,
};
